import React from 'react'
import Link from 'gatsby-link'

export default ({ to, className, children }) =>
    to.includes('http') || to.includes('www')
        ? <a href={to} className={className} target="_blank">{children}</a>
        : <Link to={to} className={className}>{children}</Link>


// WEBPACK FOOTER //
// ./src/components/Link.js